import { render, staticRenderFns } from "./MobileApps.vue?vue&type=template&id=29c421cd&"
import script from "./MobileApps.vue?vue&type=script&lang=js&"
export * from "./MobileApps.vue?vue&type=script&lang=js&"
import style0 from "./MobileApps.vue?vue&type=style&index=0&id=29c421cd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports